import Vue from 'vue'
import _ from 'lodash'
import orderApi from '@/api/order'

const state = {
    orderDetail: {},
    originOrderDetail: {},
    showModal: false,
    showCancelModal: false,
};

const actions = {
    editOrderDetailStudents({ getters, commit }) {
        orderApi.editOrderStudent({
            OrderDetailID: getters.orderDetailId,
            Students: getters.students,
        }, () => {
            commit('setOriginStudent');
            commit('setOrderDetail', {});
            commit('setShowModal', false);
        });
    },
    cancelOrderDetail({ getters, commit }, { BankID, BankAccount, BankAccountName }) {
        orderApi.cancelOrder({
            OrderDetailID: getters.orderDetailId,
            BankID,
            BankAccount,
            BankAccountName,
        }, () => {
            commit('setOriginShowCancelButton', false);
            commit('setShowCancelModal', false);
            commit('setOrderDetail', {});
        });
    },
    hide({ commit }) {
        commit('setOrderDetail', {});
        commit('setShowModal', false);
        commit('setShowCancelModal', false);
    },
};

const mutations = {
    setOriginShowCancelButton(state, showCancelButton) {
        state.originOrderDetail.ShowCancelButton = showCancelButton;
    },
    setOriginStudent(state) {
        state.originOrderDetail.student = state.orderDetail.student
    },
    setOrderDetail(state, orderDetail) {
        Vue.set(state, 'orderDetail', _.cloneDeep(orderDetail));
        Vue.set(state, 'originOrderDetail', orderDetail);
    },
    setShowModal(state, showModal) {
        state.showModal = showModal;
    },
    setShowCancelModal(state, showCancelModal) {
        state.showCancelModal = showCancelModal;
    },
    setStudent(state, {
        name,
        phone,
        email,
        index,
    }) {
        let student = state.orderDetail.student[index];

        if (name !== undefined) {
            student.Name = name;
        }

        if (phone !== undefined) {
            student.CellPhone = phone;
        }

        if (email !== undefined) {
            student.Email = email;
        }
    },
};

const getters = {
    orderDetail(state) {
        return state.orderDetail;
    },
    orderDetailId(state) {
        return _.get(state, 'orderDetail.OrderDetailId');
    },
    students(state) {
        return _.get(state, 'orderDetail.student', []);
    },
    showModal(state) {
        return state.showModal;
    },
    showCancelModal(state) {
        return state.showCancelModal;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};